export default {
      id: "ic-plan-emballages-recyclage-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-emballages-recyclage-usage",
      toString: function () {
        return this.url;
      }
    }